/** Slide type names, from the app's Resources/Xml/<lang>.xml (textId slideName*). Generated. */
export const SLIDE_NAMES: Record<string, Record<string, string>> = {
 "en": {
  "quiz": "Question",
  "quizzesQuiz": "Question",
  "trueFalse": "True or False",
  "typeAnswer": "Type Answer",
  "math": "Math operation",
  "missingLetter": "The missing letter",
  "missingWord": "The missing word",
  "order": "Order",
  "free": "Slide",
  "drag": "Drag to Containers",
  "memory": "Find the Match",
  "connect": "Connect",
  "fillWithLetters": "Type Word",
  "word": "Guess the Word",
  "sequencesImg": "Sequence",
  "tapIt": "Tap It",
  "dragText": "Drag Words",
  "traceable": "Connect the Dots",
  "puzzle": "Puzzle",
  "paint": "Paint",
  "simbolDraw": "Trace Symbol",
  "phrase": "Construct Sentence"
 },
 "es": {
  "quiz": "Pregunta",
  "quizzesQuiz": "Pregunta",
  "trueFalse": "Verdadero o Falso",
  "typeAnswer": "Escribir la respuesta",
  "math": "Operación matemática",
  "missingLetter": "La letra que falta",
  "missingWord": "La palabra que falta",
  "order": "Ordenar",
  "free": "Diapositiva",
  "drag": "Arrastrar a contenedores",
  "memory": "Encontrar la pareja",
  "connect": "Conectar",
  "fillWithLetters": "Escribir la palabra",
  "word": "Adivinar la palabra",
  "sequencesImg": "Secuencia",
  "tapIt": "Tócalo",
  "dragText": "Arrastrar palabras",
  "traceable": "Unir puntos",
  "puzzle": "Puzle",
  "paint": "Pintar y colorear",
  "simbolDraw": "Reseguir símbolo",
  "phrase": "Construir frase"
 },
 "ca": {
  "quiz": "Pregunta",
  "quizzesQuiz": "Pregunta",
  "trueFalse": "Cert o fals",
  "typeAnswer": "Escriu resposta",
  "math": "Operació matemàtica",
  "missingLetter": "La lletra que falta",
  "missingWord": "La paraula que falta",
  "order": "Ordenar",
  "free": "Diapositiva",
  "drag": "Arrossegar a contenidors",
  "memory": "Trobar parelles",
  "connect": "Connectar",
  "fillWithLetters": "Escriure paraula",
  "word": "Encertar la paraula",
  "sequencesImg": "Seqüència",
  "tapIt": "Toca’l",
  "dragText": "Arrossegar paraules",
  "traceable": "Unir punts",
  "puzzle": "Puzle",
  "paint": "Pintar",
  "simbolDraw": "Resseguir símbols",
  "phrase": "Construir frase"
 },
 "fr": {
  "quiz": "Question",
  "quizzesQuiz": "Question",
  "trueFalse": "Vrai ou faux",
  "typeAnswer": "Taper la réponse",
  "math": "Opération mathématique",
  "missingLetter": "La lettre manquante",
  "missingWord": "Le mot manquant",
  "order": "Ordre",
  "free": "Diapositive",
  "drag": "Glisser vers les conteneurs",
  "memory": "Retrouver les paires",
  "connect": "Connecter",
  "fillWithLetters": "Écrire le mot",
  "word": "Deviner le mot",
  "sequencesImg": "Séquence",
  "tapIt": "Touchez-le",
  "dragText": "Faire glisser les mots",
  "traceable": "Connecter des points",
  "puzzle": "Puzzle",
  "paint": "Peindre et colorier",
  "simbolDraw": "Suivre le symbole",
  "phrase": "Construire une phrase"
 },
 "pt": {
  "quiz": "Pergunta",
  "quizzesQuiz": "Pergunta",
  "trueFalse": "Verdadeiro ou Falso",
  "typeAnswer": "Escreva a resposta",
  "math": "Operação matemática",
  "missingLetter": "Qual a letra que falta",
  "missingWord": "Qual a palavra que falta",
  "order": "Ordem",
  "free": "Diapositivo",
  "drag": "Arrastar para contentores",
  "memory": "Encontrar o par",
  "connect": "Ligar",
  "fillWithLetters": "Escreva a palavra",
  "word": "Adivinhar a palavra",
  "sequencesImg": "Sequência",
  "tapIt": "Toca-lhe",
  "dragText": "Arrastar palavras",
  "traceable": "Unir pontos",
  "puzzle": "Quebra-cabeças",
  "paint": "Pintar e colorir",
  "simbolDraw": "Seguir o símbolo",
  "phrase": "Construir frase"
 },
 "it": {
  "quiz": "Domanda",
  "quizzesQuiz": "Domanda",
  "trueFalse": "Vero o Falso",
  "typeAnswer": "Tipo di risposta",
  "math": "Operazione matematica",
  "missingLetter": "La lettera mancante",
  "missingWord": "La parola mancante",
  "order": "Ordine",
  "free": "Diapositiva",
  "drag": "Trascinare nei contenitori",
  "memory": "Trovare il partner",
  "connect": "Connettere",
  "fillWithLetters": "Scrivi la parola",
  "word": "Indovinare la parola",
  "sequencesImg": "Sequenza",
  "tapIt": "Toccala",
  "dragText": "Trascinare parole",
  "traceable": "Collegare punti",
  "puzzle": "Puzzle",
  "paint": "Dipingere e colorare",
  "simbolDraw": "Seguire simbolo",
  "phrase": "Costruire frase"
 },
 "de": {
  "quiz": "Frage",
  "quizzesQuiz": "Frage",
  "trueFalse": "Richtig oder Falsch",
  "typeAnswer": "Antwort eingeben",
  "math": "Mathematische Operation",
  "missingLetter": "Der fehlende Buchstabe",
  "missingWord": "Das fehlende Wort",
  "order": "Sortieren",
  "free": "Folie",
  "drag": "Auf die Container ziehen",
  "memory": "Partner finden",
  "connect": "Verbinden",
  "fillWithLetters": "Schreibe das Wort",
  "word": "Das Wort raten",
  "sequencesImg": "Sequenz",
  "tapIt": "Berühren Sie es",
  "dragText": "Wörter ziehen",
  "traceable": "Punkte verbinden",
  "puzzle": "Rätsel",
  "paint": "Malen und einfärben",
  "simbolDraw": "Dem Symbol folgen",
  "phrase": "Satz bilden"
 },
 "ar": {
  "quiz": "إسأل",
  "quizzesQuiz": "إسأل",
  "trueFalse": "صواب أم خطأ",
  "typeAnswer": "اكتب الإجابة",
  "math": "عملية حسابية",
  "missingLetter": "الحرف المفقود",
  "missingWord": "الكلمة المفقودة",
  "order": "تنظم",
  "free": "العرض",
  "drag": "اسحب إلى الحاويات",
  "memory": "ابحث عن الشريك",
  "connect": "اتصل",
  "fillWithLetters": "اكتب الكلمة",
  "word": "خمن الكلمة",
  "sequencesImg": "تسلسل",
  "tapIt": "المسه",
  "dragText": "اسحب الكلمات",
  "traceable": "اربط النقاط",
  "puzzle": "لغز",
  "paint": "اطلي ولوّن",
  "simbolDraw": "اتبع الرمز",
  "phrase": "بناء الجملة"
 },
 "eu": {
  "quiz": "Galdera",
  "quizzesQuiz": "Galdera",
  "trueFalse": "Egia ala gezurra",
  "typeAnswer": "Idatzi erantzuna",
  "math": "Eragiketa matematikoa",
  "missingLetter": "Falta den letra",
  "missingWord": "Falta den hitza",
  "order": "Ordenatu",
  "free": "Diapositiba",
  "drag": "Arrastatu edukiontzietara",
  "memory": "Bilatu bikotea",
  "connect": "Lotu",
  "fillWithLetters": "Idatzi hitza",
  "word": "Asmatu hitza",
  "sequencesImg": "Sekuentziak",
  "tapIt": "Ukitu",
  "dragText": "Arrastatu hitzak",
  "traceable": "Lotu puntuak",
  "puzzle": "Puzzlea",
  "paint": "Margotu",
  "simbolDraw": "Trazatu ikurra",
  "phrase": "Osatu esaldia"
 },
 "gl": {
  "quiz": "Pregunta",
  "quizzesQuiz": "Pregunta",
  "trueFalse": "Verdadeiro ou falso",
  "typeAnswer": "Escribir a resposta",
  "math": "Operación matemática",
  "missingLetter": "A letra que falta",
  "missingWord": "A palabra que falta",
  "order": "Ordenar",
  "free": "Diapositiva",
  "drag": "Arrastrar a contedores",
  "memory": "Atopar a parella",
  "connect": "Conectar",
  "fillWithLetters": "Escribir a palabra",
  "word": "Adiviñar a palabra",
  "sequencesImg": "Secuencias",
  "tapIt": "Tócao",
  "dragText": "Arrastrar palabras",
  "traceable": "Unir os puntos",
  "puzzle": "Crebacabezas",
  "paint": "Pintar",
  "simbolDraw": "Repasar o símbolo",
  "phrase": "Construír a frase"
 },
 "nl": {
  "quiz": "Vraag",
  "quizzesQuiz": "Vraag",
  "trueFalse": "Waar of niet waar",
  "typeAnswer": "Antwoord typen",
  "math": "Rekensom",
  "missingLetter": "De ontbrekende letter",
  "missingWord": "Het ontbrekende woord",
  "order": "Ordenen",
  "free": "Dia",
  "drag": "Slepen naar vakken",
  "memory": "Zoek het paar",
  "connect": "Verbinden",
  "fillWithLetters": "Woord typen",
  "word": "Raad het woord",
  "sequencesImg": "Reeksen",
  "tapIt": "Tik erop",
  "dragText": "Woorden slepen",
  "traceable": "Verbind de puntjes",
  "puzzle": "Puzzel",
  "paint": "Schilderen en kleuren",
  "simbolDraw": "Symbool natekenen",
  "phrase": "Zin bouwen"
 },
 "pl": {
  "quiz": "Pytanie",
  "quizzesQuiz": "Pytanie",
  "trueFalse": "Prawda czy fałsz",
  "typeAnswer": "Wpisz odpowiedź",
  "math": "Działanie matematyczne",
  "missingLetter": "Brakująca litera",
  "missingWord": "Brakujące słowo",
  "order": "Uporządkuj",
  "free": "Slajd",
  "drag": "Przeciągnij do pojemników",
  "memory": "Znajdź parę",
  "connect": "Połącz",
  "fillWithLetters": "Wpisz słowo",
  "word": "Odgadnij słowo",
  "sequencesImg": "Sekwencje",
  "tapIt": "Dotknij",
  "dragText": "Przeciągnij słowa",
  "traceable": "Połącz kropki",
  "puzzle": "Puzzle",
  "paint": "Maluj",
  "simbolDraw": "Rysuj po śladzie",
  "phrase": "Ułóż zdanie"
 },
 "ro": {
  "quiz": "Întrebare",
  "quizzesQuiz": "Întrebare",
  "trueFalse": "Adevărat sau fals",
  "typeAnswer": "Scrie răspunsul",
  "math": "Operație matematică",
  "missingLetter": "Litera lipsă",
  "missingWord": "Cuvântul lipsă",
  "order": "Ordonează",
  "free": "Diapozitiv",
  "drag": "Trage în containere",
  "memory": "Găsește perechea",
  "connect": "Unește",
  "fillWithLetters": "Scrie cuvântul",
  "word": "Ghicește cuvântul",
  "sequencesImg": "Secvențe",
  "tapIt": "Atinge-l",
  "dragText": "Trage cuvintele",
  "traceable": "Unește punctele",
  "puzzle": "Puzzle",
  "paint": "Colorează",
  "simbolDraw": "Trasează simbolul",
  "phrase": "Construiește propoziția"
 },
 "sv": {
  "quiz": "Fråga",
  "quizzesQuiz": "Fråga",
  "trueFalse": "Sant eller falskt",
  "typeAnswer": "Skriv svaret",
  "math": "Räkneuppgift",
  "missingLetter": "Bokstaven som saknas",
  "missingWord": "Ordet som saknas",
  "order": "Ordna",
  "free": "Sida",
  "drag": "Dra till behållare",
  "memory": "Hitta paret",
  "connect": "Koppla ihop",
  "fillWithLetters": "Skriv ordet",
  "word": "Gissa ordet",
  "sequencesImg": "Sekvenser",
  "tapIt": "Tryck på rätt",
  "dragText": "Dra orden",
  "traceable": "Prick till prick",
  "puzzle": "Pussel",
  "paint": "Måla",
  "simbolDraw": "Spåra symbolen",
  "phrase": "Bygg en mening"
 },
 "el": {
  "quiz": "Ερώτηση",
  "quizzesQuiz": "Ερώτηση",
  "trueFalse": "Σωστό ή λάθος",
  "typeAnswer": "Γράψε την απάντηση",
  "math": "Μαθηματική πράξη",
  "missingLetter": "Το γράμμα που λείπει",
  "missingWord": "Η λέξη που λείπει",
  "order": "Βάλε σε σειρά",
  "free": "Διαφάνεια",
  "drag": "Σύρε στα κουτιά",
  "memory": "Βρες το ζευγάρι",
  "connect": "Ένωσε",
  "fillWithLetters": "Γράψε τη λέξη",
  "word": "Μάντεψε τη λέξη",
  "sequencesImg": "Ακολουθίες",
  "tapIt": "Πάτησέ το",
  "dragText": "Σύρε τις λέξεις",
  "traceable": "Ένωσε τις τελείες",
  "puzzle": "Παζλ",
  "paint": "Ζωγράφισε",
  "simbolDraw": "Ιχνηλάτησε το σύμβολο",
  "phrase": "Φτιάξε την πρόταση"
 },
 "tr": {
  "quiz": "Soru",
  "quizzesQuiz": "Soru",
  "trueFalse": "Doğru / Yanlış",
  "typeAnswer": "Cevabı yaz",
  "math": "Matematik işlemi",
  "missingLetter": "Eksik harf",
  "missingWord": "Eksik kelime",
  "order": "Sıraya koy",
  "free": "Slayt",
  "drag": "Kutulara sürükle",
  "memory": "Eşini bul",
  "connect": "Birleştir",
  "fillWithLetters": "Kelimeyi yaz",
  "word": "Kelimeyi tahmin et",
  "sequencesImg": "Diziler",
  "tapIt": "Dokun",
  "dragText": "Kelimeleri sürükle",
  "traceable": "Noktaları birleştir",
  "puzzle": "Yapboz",
  "paint": "Boya",
  "simbolDraw": "Sembolü çiz",
  "phrase": "Cümle kur"
 },
 "ru": {
  "quiz": "Вопрос",
  "quizzesQuiz": "Вопрос",
  "trueFalse": "Верно или неверно",
  "typeAnswer": "Написать ответ",
  "math": "Решить пример",
  "missingLetter": "Пропущенная буква",
  "missingWord": "Пропущенное слово",
  "order": "Упорядочить",
  "free": "Слайд",
  "drag": "Перетащить в контейнеры",
  "memory": "Найти пару",
  "connect": "Соединить",
  "fillWithLetters": "Написать слово",
  "word": "Угадать слово",
  "sequencesImg": "Последовательности",
  "tapIt": "Нажать на нужное",
  "dragText": "Перетащить слова",
  "traceable": "Соединить точки",
  "puzzle": "Пазл",
  "paint": "Раскраска",
  "simbolDraw": "Обвести символ",
  "phrase": "Составить предложение"
 },
 "uk": {
  "quiz": "Запитання",
  "quizzesQuiz": "Запитання",
  "trueFalse": "Правда чи неправда",
  "typeAnswer": "Ввести відповідь",
  "math": "Математична дія",
  "missingLetter": "Пропущена літера",
  "missingWord": "Пропущене слово",
  "order": "Упорядкувати",
  "free": "Слайд",
  "drag": "Перетягнути в контейнери",
  "memory": "Знайти пару",
  "connect": "З’єднати",
  "fillWithLetters": "Написати слово",
  "word": "Вгадати слово",
  "sequencesImg": "Послідовності",
  "tapIt": "Торкнутися",
  "dragText": "Перетягнути слова",
  "traceable": "З’єднати точки",
  "puzzle": "Пазл",
  "paint": "Розфарбувати",
  "simbolDraw": "Обвести символ",
  "phrase": "Скласти речення"
 },
 "id": {
  "quiz": "Pertanyaan",
  "quizzesQuiz": "Pertanyaan",
  "trueFalse": "Benar atau Salah",
  "typeAnswer": "Ketik Jawaban",
  "math": "Operasi Hitung",
  "missingLetter": "Huruf yang Hilang",
  "missingWord": "Kata yang Hilang",
  "order": "Urutkan",
  "free": "Slide",
  "drag": "Seret ke Wadah",
  "memory": "Cari Pasangan",
  "connect": "Hubungkan",
  "fillWithLetters": "Ketik Kata",
  "word": "Tebak Kata",
  "sequencesImg": "Urutan",
  "tapIt": "Ketuk",
  "dragText": "Seret Kata",
  "traceable": "Hubungkan Titik",
  "puzzle": "Puzzle",
  "paint": "Mewarnai",
  "simbolDraw": "Tebalkan Simbol",
  "phrase": "Susun Kalimat"
 },
 "vi": {
  "quiz": "Câu hỏi",
  "quizzesQuiz": "Câu hỏi",
  "trueFalse": "Đúng hay sai",
  "typeAnswer": "Nhập câu trả lời",
  "math": "Phép tính",
  "missingLetter": "Chữ cái còn thiếu",
  "missingWord": "Từ còn thiếu",
  "order": "Sắp xếp",
  "free": "Trang chiếu",
  "drag": "Kéo vào hộp chứa",
  "memory": "Tìm cặp",
  "connect": "Nối",
  "fillWithLetters": "Nhập từ",
  "word": "Đoán từ",
  "sequencesImg": "Chuỗi",
  "tapIt": "Chạm vào",
  "dragText": "Kéo các từ",
  "traceable": "Nối các điểm",
  "puzzle": "Ghép hình",
  "paint": "Tô màu",
  "simbolDraw": "Đồ theo ký hiệu",
  "phrase": "Ghép câu"
 },
 "cs": {
  "quiz": "Otázka",
  "quizzesQuiz": "Otázka",
  "trueFalse": "Pravda, nebo nepravda",
  "typeAnswer": "Napsat odpověď",
  "math": "Matematická operace",
  "missingLetter": "Chybějící písmeno",
  "missingWord": "Chybějící slovo",
  "order": "Seřadit",
  "free": "Snímek",
  "drag": "Přetáhnout do přihrádek",
  "memory": "Pexeso",
  "connect": "Spojit",
  "fillWithLetters": "Napsat slovo",
  "word": "Uhodnout slovo",
  "sequencesImg": "Řady",
  "tapIt": "Klepnout",
  "dragText": "Přetáhnout slova",
  "traceable": "Spojit tečky",
  "puzzle": "Skládačka",
  "paint": "Malovat",
  "simbolDraw": "Obtáhnout symbol",
  "phrase": "Sestavit větu"
 },
 "sk": {
  "quiz": "Otázka",
  "quizzesQuiz": "Otázka",
  "trueFalse": "Pravda alebo nepravda",
  "typeAnswer": "Napísať odpoveď",
  "math": "Matematická operácia",
  "missingLetter": "Chýbajúce písmeno",
  "missingWord": "Chýbajúce slovo",
  "order": "Zoradiť",
  "free": "Strana",
  "drag": "Presunúť do kontajnerov",
  "memory": "Nájsť dvojicu",
  "connect": "Spojiť",
  "fillWithLetters": "Napísať slovo",
  "word": "Uhádnuť slovo",
  "sequencesImg": "Postupnosti",
  "tapIt": "Ťuknúť",
  "dragText": "Presunúť slová",
  "traceable": "Spojiť bodky",
  "puzzle": "Skladačka",
  "paint": "Maľovať",
  "simbolDraw": "Obťahovať symbol",
  "phrase": "Zostaviť vetu"
 },
 "hu": {
  "quiz": "Kérdés",
  "quizzesQuiz": "Kérdés",
  "trueFalse": "Igaz vagy hamis",
  "typeAnswer": "Válasz beírása",
  "math": "Matematikai művelet",
  "missingLetter": "A hiányzó betű",
  "missingWord": "A hiányzó szó",
  "order": "Sorba rendezés",
  "free": "Dia",
  "drag": "Húzás tárolókba",
  "memory": "Párkereső",
  "connect": "Összekötés",
  "fillWithLetters": "Szó beírása",
  "word": "Találd ki a szót",
  "sequencesImg": "Sorozatok",
  "tapIt": "Koppints rá",
  "dragText": "Szavak húzása",
  "traceable": "Pontösszekötő",
  "puzzle": "Kirakó",
  "paint": "Kifestő",
  "simbolDraw": "Jel átrajzolása",
  "phrase": "Mondatalkotás"
 },
 "hr": {
  "quiz": "Pitanje",
  "quizzesQuiz": "Pitanje",
  "trueFalse": "Točno ili netočno",
  "typeAnswer": "Upiši odgovor",
  "math": "Računska operacija",
  "missingLetter": "Slovo koje nedostaje",
  "missingWord": "Riječ koja nedostaje",
  "order": "Redoslijed",
  "free": "Slajd",
  "drag": "Povuci u kutije",
  "memory": "Pronađi par",
  "connect": "Poveži",
  "fillWithLetters": "Upiši riječ",
  "word": "Pogodi riječ",
  "sequencesImg": "Nizovi",
  "tapIt": "Dodirni",
  "dragText": "Povuci riječi",
  "traceable": "Spoji točke",
  "puzzle": "Slagalica",
  "paint": "Bojanje",
  "simbolDraw": "Iscrtaj simbol",
  "phrase": "Složi rečenicu"
 },
 "bg": {
  "quiz": "Въпрос",
  "quizzesQuiz": "Въпрос",
  "trueFalse": "Вярно или невярно",
  "typeAnswer": "Писмен отговор",
  "math": "Математическо действие",
  "missingLetter": "Липсващата буква",
  "missingWord": "Липсващата дума",
  "order": "Подреждане",
  "free": "Слайд",
  "drag": "Плъзгане в контейнери",
  "memory": "Намиране на двойки",
  "connect": "Свързване",
  "fillWithLetters": "Писане на дума",
  "word": "Отгатване на дума",
  "sequencesImg": "Последователност",
  "tapIt": "Докосване",
  "dragText": "Плъзгане на думи",
  "traceable": "Свързване на точки",
  "puzzle": "Пъзел",
  "paint": "Оцветяване",
  "simbolDraw": "Очертаване на символ",
  "phrase": "Съставяне на изречение"
 },
 "da": {
  "quiz": "Spørgsmål",
  "quizzesQuiz": "Spørgsmål",
  "trueFalse": "Sandt eller falsk",
  "typeAnswer": "Skriv svaret",
  "math": "Regnestykke",
  "missingLetter": "Det manglende bogstav",
  "missingWord": "Det manglende ord",
  "order": "Sæt i rækkefølge",
  "free": "Side",
  "drag": "Træk til beholdere",
  "memory": "Find parret",
  "connect": "Forbind",
  "fillWithLetters": "Skriv ordet",
  "word": "Gæt ordet",
  "sequencesImg": "Sekvenser",
  "tapIt": "Tryk på det rigtige",
  "dragText": "Træk ordene",
  "traceable": "Forbind prikkerne",
  "puzzle": "Puslespil",
  "paint": "Mal",
  "simbolDraw": "Tegn symbolet efter",
  "phrase": "Byg en sætning"
 },
 "nb": {
  "quiz": "Spørsmål",
  "quizzesQuiz": "Spørsmål",
  "trueFalse": "Sant eller usant",
  "typeAnswer": "Skriv svaret",
  "math": "Regnestykke",
  "missingLetter": "Bokstaven som mangler",
  "missingWord": "Ordet som mangler",
  "order": "Sorter",
  "free": "Side",
  "drag": "Dra til beholdere",
  "memory": "Finn paret",
  "connect": "Koble sammen",
  "fillWithLetters": "Skriv ordet",
  "word": "Gjett ordet",
  "sequencesImg": "Rekkefølger",
  "tapIt": "Trykk på riktig",
  "dragText": "Dra ordene",
  "traceable": "Prikk til prikk",
  "puzzle": "Puslespill",
  "paint": "Fargelegg",
  "simbolDraw": "Spor symbolet",
  "phrase": "Bygg setningen"
 },
 "fi": {
  "quiz": "Kysymys",
  "quizzesQuiz": "Kysymys",
  "trueFalse": "Totta vai tarua",
  "typeAnswer": "Kirjoita vastaus",
  "math": "Laskutoimitus",
  "missingLetter": "Puuttuva kirjain",
  "missingWord": "Puuttuva sana",
  "order": "Järjestä",
  "free": "Sisältösivu",
  "drag": "Vedä laatikoihin",
  "memory": "Etsi pari",
  "connect": "Yhdistä",
  "fillWithLetters": "Kirjoita sana",
  "word": "Arvaa sana",
  "sequencesImg": "Sarjat",
  "tapIt": "Napauta",
  "dragText": "Vedä sanat",
  "traceable": "Yhdistä pisteet",
  "puzzle": "Palapeli",
  "paint": "Maalaa",
  "simbolDraw": "Jäljennä merkki",
  "phrase": "Rakenna lause"
 },
 "fa": {
  "quiz": "سؤال",
  "quizzesQuiz": "سؤال",
  "trueFalse": "درست یا نادرست",
  "typeAnswer": "تایپ پاسخ",
  "math": "عملیات ریاضی",
  "missingLetter": "حرف جاافتاده",
  "missingWord": "کلمه جاافتاده",
  "order": "مرتب‌سازی",
  "free": "اسلاید",
  "drag": "کشیدن به جعبه‌ها",
  "memory": "پیدا کردن جفت‌ها",
  "connect": "وصل کردن",
  "fillWithLetters": "تایپ کلمه",
  "word": "حدس کلمه",
  "sequencesImg": "دنباله‌ها",
  "tapIt": "لمس کردن",
  "dragText": "کشیدن کلمه‌ها",
  "traceable": "وصل کردن نقطه‌ها",
  "puzzle": "پازل",
  "paint": "رنگ‌آمیزی",
  "simbolDraw": "رسم نماد",
  "phrase": "ساختن جمله"
 },
 "ur": {
  "quiz": "سوال",
  "quizzesQuiz": "سوال",
  "trueFalse": "صحیح یا غلط",
  "typeAnswer": "جواب لکھیں",
  "math": "ریاضی کا سوال",
  "missingLetter": "غائب حرف",
  "missingWord": "غائب لفظ",
  "order": "ترتیب دیں",
  "free": "سلائیڈ",
  "drag": "خانوں میں گھسیٹیں",
  "memory": "جوڑی تلاش کریں",
  "connect": "جوڑیں",
  "fillWithLetters": "لفظ لکھیں",
  "word": "لفظ بوجھیں",
  "sequencesImg": "سلسلے",
  "tapIt": "چھوئیں",
  "dragText": "الفاظ گھسیٹیں",
  "traceable": "نقطے ملائیں",
  "puzzle": "پزل",
  "paint": "رنگ بھریں",
  "simbolDraw": "علامت پر لکھیں",
  "phrase": "جملہ بنائیں"
 },
 "ms": {
  "quiz": "Soalan",
  "quizzesQuiz": "Soalan",
  "trueFalse": "Betul atau Salah",
  "typeAnswer": "Taip Jawapan",
  "math": "Operasi Matematik",
  "missingLetter": "Huruf yang Hilang",
  "missingWord": "Perkataan yang Hilang",
  "order": "Susun",
  "free": "Slaid",
  "drag": "Seret ke Bekas",
  "memory": "Cari Pasangan",
  "connect": "Sambungkan",
  "fillWithLetters": "Taip Perkataan",
  "word": "Teka Perkataan",
  "sequencesImg": "Urutan",
  "tapIt": "Ketik",
  "dragText": "Seret Perkataan",
  "traceable": "Sambung Titik",
  "puzzle": "Teka-teki Gambar",
  "paint": "Mewarna",
  "simbolDraw": "Surih Simbol",
  "phrase": "Bina Ayat"
 },
 "az": {
  "quiz": "Sual",
  "quizzesQuiz": "Sual",
  "trueFalse": "Doğru və ya yanlış",
  "typeAnswer": "Cavabı yaz",
  "math": "Riyazi əməl",
  "missingLetter": "Buraxılmış hərf",
  "missingWord": "Buraxılmış söz",
  "order": "Sırala",
  "free": "Slayd",
  "drag": "Qutulara sürüşdür",
  "memory": "Cütü tap",
  "connect": "Birləşdir",
  "fillWithLetters": "Sözü yaz",
  "word": "Sözü tap",
  "sequencesImg": "Ardıcıllıq",
  "tapIt": "Toxun",
  "dragText": "Sözləri sürüşdür",
  "traceable": "Nöqtələri birləşdir",
  "puzzle": "Pazl",
  "paint": "Rənglə",
  "simbolDraw": "Simvolu çək",
  "phrase": "Cümlə qur"
 },
 "uz": {
  "quiz": "Savol",
  "quizzesQuiz": "Savol",
  "trueFalse": "Toʻgʻri yoki notoʻgʻri",
  "typeAnswer": "Javobni yozing",
  "math": "Matematik amal",
  "missingLetter": "Tushib qolgan harf",
  "missingWord": "Tushib qolgan soʻz",
  "order": "Tartiblash",
  "free": "Slayd",
  "drag": "Qutilarga torting",
  "memory": "Juftini toping",
  "connect": "Bogʻlash",
  "fillWithLetters": "Soʻzni yozing",
  "word": "Soʻzni toping",
  "sequencesImg": "Ketma-ketlik",
  "tapIt": "Bosib toping",
  "dragText": "Soʻzlarni torting",
  "traceable": "Nuqtalarni tutashtiring",
  "puzzle": "Boshqotirma",
  "paint": "Boʻyash",
  "simbolDraw": "Belgini chizing",
  "phrase": "Gap tuzing"
 },
 "fil": {
  "quiz": "Tanong",
  "quizzesQuiz": "Tanong",
  "trueFalse": "Tama o Mali",
  "typeAnswer": "I-type ang Sagot",
  "math": "Operasyon sa Math",
  "missingLetter": "Nawawalang Titik",
  "missingWord": "Nawawalang Salita",
  "order": "Pagsunud-sunurin",
  "free": "Slide",
  "drag": "I-drag sa Lalagyan",
  "memory": "Hanapin ang Kapares",
  "connect": "Pagdugtungin",
  "fillWithLetters": "I-type ang Salita",
  "word": "Hulaan ang Salita",
  "sequencesImg": "Pagkakasunod-sunod",
  "tapIt": "I-tap",
  "dragText": "I-drag ang mga Salita",
  "traceable": "Pagdugtungin ang mga Tuldok",
  "puzzle": "Puzzle",
  "paint": "Kulayan",
  "simbolDraw": "Bakatin ang Simbolo",
  "phrase": "Buuin ang Pangungusap"
 }
};

export function slideTypeName(type: string, lang: string): string {
  return SLIDE_NAMES[lang]?.[type] ?? SLIDE_NAMES.en[type] ?? type;
}
